import Button from "components/common/Button";

/** Prototype ICONS.shield (outline, 24px grid). */
const SHIELD = "M12 3a12 12 0 0 0 8.5 3A12 12 0 0 1 12 21 12 12 0 0 1 3.5 6 12 12 0 0 0 12 3 M9 12l2 2 4-4";

interface Props {
  /** "Sign up with a business email": back to the sign-in card. */
  onSignUpAgain: () => void;
}

/**
 * Prototype renderBlocked (1d): a public-email sign-up is created blocked and stops here, before the portal.
 * A holding screen, not an error: one line icon, the words, one action. Shown for ACCOUNT_BLOCKED.
 */
function BusinessEmailCard({ onSignUpAgain }: Props) {
  return (
    <div className="plg-bk" role="alert">
      <div className="plg-ic-tile" aria-hidden="true">
        <svg className="plg-line-icon" viewBox="0 0 24 24">
          <path d={SHIELD} />
        </svg>
      </div>
      <h1 className="plg-signup__title">We need a business email</h1>
      <p className="plg-signup__sub">We&apos;re reviewing your request.</p>
      <p className="plg-signup__sub plg-bk__next">
        The quickest way in is to sign up again with your business email. Business accounts get access straight away.
      </p>
      <div className="plg-bk__action">
        <Button variant="contained" size="large" label="Sign up with a business email" onClick={onSignUpAgain} isFullWidth />
      </div>
      <p className="plg-bk__quiet">No business email? We&apos;ll be in touch after reviewing your request.</p>
    </div>
  );
}

export default BusinessEmailCard;
